module.exports = __webpack_public_path__ + "img/skramble-it.31b50847.svg";